<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="{ name: routeName.PROPAGANDIST }" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="can('edit propagandists')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editPropagandist"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deletePropagandist">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="value"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#propagandist">
          {{ $t('PROPAGANDIST') }}
        </v-tab>
        <v-tab dark href="#school">
          {{ $t('SCHOOL') }}
        </v-tab>
        <v-tab dark href="#statistic">
          {{ $t('STATISTIC') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  export default {
    name: 'PropagandistTabs',
    props: {
      propagandist: Object,
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      deletePropagandist() {
        this.$emit('delete');
      },

      editPropagandist() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
  };
</script>
